import { render } from "./AuthWrapper.vue?vue&type=template&id=fd1a0fb2&ts=true&lang=pug"
import script from "./AuthWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthWrapper.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__